import { useState } from 'react'
import { X, ZoomIn, Download } from 'lucide-react'
import { getImageUrl } from '../utils/apiUrl'
import ProductImage from './ProductImage'

const ImageGallery = ({ 
  imageUrl, 
  alt, 
  className = "w-full h-full object-cover",
  showDownload = true 
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleDownload = () => {
    if (imageUrl) {
      const link = document.createElement('a')
      link.href = getImageUrl(imageUrl)
      link.download = alt || 'image'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  return (
    <>
      {/* Image principale cliquable */}
      <div 
        className="relative cursor-pointer group"
        onClick={() => setIsModalOpen(true)}
      >
        <ProductImage
          imageUrl={imageUrl}
          alt={alt}
          className={className}
          showLoading={true}
        />
        
        {/* Overlay avec bouton zoom */}
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
          <div className="bg-white bg-opacity-90 rounded-full p-3">
            <ZoomIn className="h-6 w-6 text-gray-800" />
          </div>
        </div>
      </div>

      {/* Modal plein écran */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl max-h-full">
            {/* Bouton fermer */}
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-4 right-4 z-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-2 transition-all duration-200"
            >
              <X className="h-6 w-6 text-white" />
            </button>

            {/* Bouton télécharger */}
            {showDownload && imageUrl && (
              <button
                onClick={handleDownload}
                className="absolute top-4 right-16 z-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-2 transition-all duration-200"
                title="Télécharger l'image"
              >
                <Download className="h-6 w-6 text-white" />
              </button>
            )}

            {/* Image en grand */}
            <div className="max-w-full max-h-[80vh] overflow-hidden rounded-lg">
              <ProductImage
                imageUrl={imageUrl}
                alt={alt}
                className="w-full h-full object-contain"
                showLoading={true}
              />
            </div>

            {/* Légende */}
            <div className="absolute bottom-4 left-4 right-4 bg-black bg-opacity-50 text-white p-3 rounded-lg">
              <p className="text-sm">{alt}</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ImageGallery
